module.exports = __webpack_public_path__ + "img/historial-bco.ad63c594.svg";